module.exports = __webpack_public_path__ + "img/image87.6baefd5.jpg";